import React, { useEffect, useState } from "react"
import VisitListItem from "./VisitListItem"

const VisitList = props => {
  const [visits, setVisits] = useState([])

  useEffect(() => {
    setVisits(props.visits)
  }, [props])

  return (
    <div>
      {visits && visits.length > 0 ? (
        <div className="visits-adaptive-grid">
          {visits.map((item: any, index: number) => (
            <div key={index} className="visit-card-wrapper">
              <VisitListItem model={item} />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
          <i className="fa fa-calendar-times fa-3x text-muted mb-3"></i>
          <p className="text-muted h5">No hay visitas registradas</p>
          <p className="text-muted">Las visitas aparecerán aquí cuando sean creadas</p>
        </div>
      )}
    </div>
  )
}

export default VisitList
